import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InstagramComparePosts.graphql';
import { Query, QueryinstagramComparePostsArgs } from '../../__generated__/globalTypes';

export const useInstagramComparePostsQuery = (options?: QueryHookOptions<Query, QueryinstagramComparePostsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinstagramComparePostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInstagramComparePostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinstagramComparePostsArgs>
): QueryResult<Query, QueryinstagramComparePostsArgs> & {
  getInstagramComparePosts: LazyQueryExecFunction<Query, QueryinstagramComparePostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInstagramComparePosts, result] = useLazyQuery<Query, QueryinstagramComparePostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInstagramComparePosts, ...result };
};

export const useInstagramComparePostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInstagramComparePosts = useCallback(
    (options?: Omit<QueryOptions<QueryinstagramComparePostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinstagramComparePostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInstagramComparePosts };
};
// Suspense Query Hooks
export const useInstagramComparePostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinstagramComparePostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinstagramComparePostsArgs>(QUERY, {
    ...options
  });

  return result;
};
